exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FourOhFour h1 {\n  font-family: AachenPro-Bold, \"Open Sans\", Arial, Helvetica, sans-serif;\n  font-size: 48px;\n  text-transform: uppercase;\n}\n.FourOhFour h3 {\n  text-transform: none;\n}\n", ""]);

